import { render, staticRenderFns } from "./XlsxGameDownload.vue?vue&type=template&id=554d88a0"
import script from "./XlsxGameDownload.vue?vue&type=script&lang=js"
export * from "./XlsxGameDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports